import con from '../../../connection';
import { move } from './move';
var path = '/articles';
export var articles = function (url) { return function (article_id) { return ({
    move: move("" + url + path + "/" + article_id),
    get: function (param) { return con.get(url + path, param); },
}); }; };
